import { useCallback, useEffect, useState } from 'react';
import { useBuddi } from '@bentley/pw-config';
import { useConfigContext } from '../../../context';
import { readSearchParam } from '../searchParams/searchParams';

export type SolutionType = 'OpenConstruction' | 'ProjectWise365' | 'web';

export function useSolutionType(): SolutionType | undefined {
  const { config } = useConfigContext();

  const pwWebUrl = useBuddi('ProjectWiseWAC.URL', config.BUDDIRegionCode);

  const [solutionType, setSolutionType] = useState<SolutionType>();

  const fetchContextInfo = useCallback(
    async (projectId: string): Promise<string> => {
      try {
        // Todo: this should use the ProjectWiseWAC backend, but does not work
        // on the new pwlink alias due to an unresolved CORS error
        // For now, we assume this is being called where the origin is the same as the backend
        // See also useCannedConnection.ts
        const result = await fetch(`api/context/${projectId}`);
        const text = await result.text();
        return text;
      } catch (e) {
        console.error(e);
        return 'web';
      }
    },
    []
  );

  const getSolutionType = useCallback(async (): Promise<SolutionType> => {
    try {
      const projectId = readSearchParam(['projectId', 'p']);

      if (!projectId) {
        return 'web';
      }

      const solutionType = await fetchContextInfo(projectId);

      if (solutionType == 'ProjectWise365') {
        return 'ProjectWise365';
      }
      if (solutionType == 'OpenConstruction') {
        return 'OpenConstruction';
      }

      return 'web';
    } catch (e) {
      console.error(e);
      return 'web';
    }
  }, [fetchContextInfo]);

  useEffect(() => {
    async function initializeSolutionType(): Promise<void> {
      const solutionType = await getSolutionType();
      setSolutionType(solutionType);
    }

    if (pwWebUrl) {
      void initializeSolutionType();
    }
  }, [getSolutionType, pwWebUrl]);

  return solutionType;
}
